import { MyTenders } from './MyTenders';
import { CabinetLayout } from '@web-kc/shared/components';
import { useApp } from '@web-kc/core/providers';
import { useTranslation } from 'next-i18next';

export function MyTendersCabinetPage() {
  const isKC = useApp() === 'kc';
  const { t } = useTranslation();

  return (
    <CabinetLayout
      pageTitle={t(
        `common:pageTitle.cabinet.my-tenders.${isKC ? 'kc' : 'rti'}`,
      )}
    >
      <MyTenders type="tenders" />
    </CabinetLayout>
  );
}
